<template>
  <label class="form_search_label" for="app-search">
    <input
      id="app-search"
      v-model="search"
      :placeholder="trans('common.search')"
      class="form_search"
      type="text"
      @keydown="handleChange"
    />
    <svg class="form_search_icon">
      <use xlink:href="#search-icon"></use>
    </svg>
  </label>
</template>

<script>
export default {
  props: {
    searchValue: String,
  },
  data() {
    return {
      search: this.searchValue,
      handleChange: null,
    };
  },

  created() {
    this.handleChange = _.debounce(() => {
      this.$emit('search-changed', this.search);
    }, 500);
  },
};
</script>
